module.exports = __webpack_public_path__ + "img/flow_customer-service.83b51b5a.svg";